<template>
    <b-modal :id="'modal-upload-arquivo-usuario-externo'" size="xl" hide-footer centered title="Upload de arquivos">
    <b-form class="d-flex flex-column gap-sm">
        <b-form-row>
			<b-col>
				<label for="nomeDoArquivo">Arquivo:</label>
				<b-form-file required placeholder="Selecione um arquivo..." browse-text="Pesquisar" v-model="arquivo" accept="application/vnd.ms-powerpoint , application/pdf , application/x-rar-compressed"></b-form-file>
			</b-col>
		</b-form-row>
        <b-form-row>
            <b-col>
                <label for="descricao">Descrição:</label>
                <b-textarea v-model="descricao"></b-textarea>
            </b-col>
        </b-form-row>
		<b-form-row>
			<div id="enviarArquivo" class="ml-2">
				<b-button variant="success" @click="enviarArquivo" :disabled="carregando || arquivo == null">
					<b-spinner v-show="carregando" variant="light"></b-spinner>
					<span v-show="!carregando" >
						Enviar
					</span>
					<b-tooltip target="enviarArquivo" v-if="arquivo == null">Selecione um arquivo</b-tooltip>
			</b-button>
			</div>
		</b-form-row>
    </b-form>
    </b-modal>
</template>

<script>
import InformacoesUsuario from "../usuario/InformacoesUsuario.vue";
import TableArquivosUsuario from "../GerenciarArquivosUsuarios/TableArquivosUsuario.vue";
import ArquivoPrimesegService from "../../service/ArquivoPrimesegService.js";

export default {
	components: { TableArquivosUsuario, InformacoesUsuario },
	name: "ModalGerenciarArquivosUsuario",
	data() {
		return {
			usuario: JSON.parse(localStorage.getItem("usuario")),
			arquivo: null,
			descricao: "",
			carregando: false,
		};
	},
	methods: {
		enviarArquivo() {
			this.carregando = true;
			const usuarioLogado = JSON.parse(localStorage.getItem("usuario"));
			const form = new FormData();
			form.append("arquivo", this.arquivo);
			form.append("descricao", this.descricao);
			ArquivoPrimesegService.salvarNovoArquivo(this.usuario.id, form, usuarioLogado.id)
				.then(() => {
					this.mensagem("O upload do arquivo foi realizado com sucesso!", "Sucesso", "success");
					this.arquivo = null;
					this.descricao = null;
				}).catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível realizar o upload do arquivo nesse momento!", "Erro", "danger");
					}
				}).finally(() => {
					this.carregando = false;
				});
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	},

};
</script>



// WEBPACK FOOTER //
// src/components/GerenciarArquivosPrimeseg/ModalUploadArquivosUsuarioExterno.vue